export default __webpack_public_path__ + "static/media/phone_logo.df9690cb.png";